import ErrorPage from "@/pages/error/Error"
import React from "react"

class BasicErrorBoundary extends React.Component {
  props
  state: {
    hasError?: any
    error?: any
    unauthorized?: any
    notfound?: any
    page?: any
    pages?: any
    columnsButtonAnchorEl?: any
    exportButtonAnchorEl?: any
    isChecked?: any
    defaultColumnWidths?: any
    columns?: any
    rows?: any
    expandedRowIds?: any
  }

  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  /*
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    logErrorToMyService(error, errorInfo)
  }
  */

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage errorMessage={this.props.message} />
    }
    return this.props.children
  }
}

export default BasicErrorBoundary
